import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { SectionNumber } from '@components/Section-Number';
import { Separator } from '@components/Separator';
import { HelpBlocks } from './organism/help-blocks';
import { Information } from './organism/information';

export const AssistanceTraining = ({ locale }) => {
  const translations = useTranslations();

  return (
    <View id="assistance-training">
      <Container>
        <Content>
          <Top>
            <TopLeft>
              <SectionNumber text={translations.t('site.home.assistance.name')} />
              <Title>{translations.t('site.home.assistance.title')}</Title>
              <Description>{translations.t('site.home.assistance.description')}</Description>
            </TopLeft>
            <TopRight>
              <Text
                dangerouslySetInnerHTML={{ __html: translations.t('site.home.assistance.text').replace(/\\n/g, '\n') }}
              />
            </TopRight>
          </Top>

          <Separator />

          <HelpBlocks />
          <Information />
        </Content>
      </Container>
    </View>
  );
};

const View = styled.section`
  height: auto;
  position: relative;
  overflow: hidden;
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: ${Colors.white};

  @media ${Points.tablet_landscape} {
    padding-bottom: 52px;
  }

  @media ${Points.laptop_wide} {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  @media ${Points.fullhd} {
    padding-bottom: 130px;
  }
`;
const Container = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;

  @media ${Points.tablet_landscape} {
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    padding: 0 28px;
  }

  @media ${Points.laptop_wide} {
    padding: 0 80px;
    width: 100%;
    max-width: 1600px;
  }

  @media ${Points.fullhd} {
    padding: 0;
  }
`;
const Content = styled.div`
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
`;
const Top = styled.div`
  @media ${Points.tablet_landscape} {
    display: flex;
    justify-content: space-between;
  }
`;
const TopLeft = styled.div`
  margin-bottom: 20px;

  @media ${Points.tablet_landscape} {
    margin-bottom: 0;
    max-width: 430px;
  }

  @media ${Points.laptop_wide} {
    max-width: 592px;
  }
`;
const Title = styled.div`
  font-size: 26px;
  line-height: 1;
  margin-bottom: 16px;

  @media ${Points.tablet_landscape} {
    font-size: 34px;
    margin-bottom: 20px;
  }

  @media ${Points.laptop_wide} {
    font-size: 54px;
  }
`;
const Description = styled.div`
  font-size: 12px;
  line-height: 1.1;

  @media ${Points.laptop_wide} {
    font-size: 14px;
  }
`;
const TopRight = styled.div`
  @media ${Points.tablet_landscape} {
    max-width: 500px;
  }

  @media ${Points.laptop_wide} {
    max-width: 518px;
  }
`;
const Text = styled.div`
  font-size: 16px;
  line-height: 1.3;
  white-space: pre-line;

  @media ${Points.laptop_wide} {
    font-size: 18px;
  }
`;
